<template>
    <div class="contents">
        <div class="tw-w-full">
            <div class="tw-flex tw-flex-wrap -tw-mx-3">
                <div class="tw-w-full tw-px-3">
                    <div class="wl-page-header">
<h1 class="wl-page-title">
                                    Daftar user
                                </h1>
                        <div class="wl-page-actions">
                            <a v-on:click="toggleModal('agency_link')" class="wl-btn wl-btn-primary">
                                Link perpanjangan user agency
                            </a>
                            <a v-on:click="toggleModal('new_user')" class="wl-btn wl-btn-primary">
                                <i class="fas fa-plus tw-text-[16px]" aria-hidden="true"></i>
                                Tambah user
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="lisensiQuota == -1" class="wl-alert wl-alert-success" role="alert">
                <div>
                    <p>Batas user agency maksimal anda adalah <b>Unlimited</b> user</p>
                </div>
            </div>
            <div v-else-if="lisensiQuota == 0" class="wl-alert wl-alert-danger" role="alert">
                <div>
                    <p>Batas user agency maksimal anda adalah <b>{{ lisensiQuota }}</b> user</p>
                </div>
            </div>
            <div v-else class="wl-alert wl-alert-success" role="alert">
                <div v-if="totalRecord > 0" class="wl-alert wl-alert-danger" role="alert">
					<div>
						<p>Anda mempunyai sisa <b>{{ sisaLisensi }}</b> lisensi dari <b>{{ lisensiQuota }}</b> lisensi</p>
					</div>
				</div>
				<div v-else-if="totalRecord == 0" class="wl-alert wl-alert-success" role="alert">
					<div>
						<p>Batas user agency maksimal anda adalah <b>{{ lisensiQuota }}</b> user</p>
					</div>
				</div>
            </div>
            <div class="tw-flex tw-flex-wrap -tw-mx-3">
                <div class="tw-w-full tw-px-3">
                    <div class="wl-panel tw-w-full tw-mb-8">
                        <UserTable @changeJumlah="ChangeJ($event)" />
                    </div>
                </div>
            </div>
            <modal name="new_user" :height="'auto'" :adaptive="true" :scrollable="true">
                <div style="margin: 20px">
                    <AddUser />
                </div>
            </modal>
            <modal name="agency_link" :height="'auto'" :adaptive="true" :scrollable="true">
                <div style="margin: 20px">
                    <center>
                        <h2>Edit link perpanjangan user agency</h2>
                    </center>
                    <br>
                    <form v-on:submit.prevent="editAgencySetting">
                        <label for="">URL</label>
                        <input v-model="agencySetting.extend_url" type="text" class="wl-input" placeholder="https://example.com">
                        <br>
                        <button type="submit" class="wl-btn wl-btn-primary tw-w-full">Simpan</button>
                    </form>
                </div>
            </modal>
        </div>
    </div>
</template>

<script>
    import UserTable from "@/components/tables/UserAgency.vue";
    import AddUser from "@/components/forms/agency/AddUser.vue";

    export default {
        components: {
            UserTable,
            AddUser
        },
        data() {
            return {
                agencySetting: {
                    extend_url: ""
                },
                lisensiQuota: 0,
                totalRecord:0,
				sisaLisensi:0
            }
        },
        beforeDestroy(){
            this.$root.$off("toggle_modal", this.fnToggleModal);
        },
        mounted() {
            this.fnToggleModal = (param) => {
                this.toggleModal(param);
            }
            this.$root.$on("toggle_modal", this.fnToggleModal);

            this.lisensiQuota = this.$store.state.auth.package.lisensi
            this.loadAgencySetting()
        },
        methods: {
            ChangeJ(jml){
				this.totalRecord = jml
				this.sisaLisensi = this.lisensiQuota-jml
				
			},
            toggleModal(param) {
                this.$modal.toggle(param);
            },
            async loadAgencySetting(){
                let setting = await this.$store.dispatch('agency_setting')
                this.agencySetting = setting.data.data.setting
            },
            async editAgencySetting(){
                try{
                    let setting = await this.$store.dispatch('agency_setting_edit', this.agencySetting)
                    this.$toast.success(setting.data.message);
                    this.toggleModal("agency_link")
                }catch(err){
                    this.$toast.error(err.response.data.message);
                }

            }
        },
    };
</script>
